module.exports = __webpack_public_path__ + "static/img/homgroup.com.1b18d86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/homgroup.com.jpg
// module id = 33
// module chunks = 1